<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-autorenew"
    ></vuse-section-definition>

    <v-row class="mx-1 mt-3">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="renew.name"
            filled
            label="Tên khách hàng"
            @input="debounceInput"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="renew.phone"
            filled
            label='Số điện thoại'
            @input="debounceInput1"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="renew.address"
            filled
            label="Nơi cư trú"
            @input="debounceInputAddress"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="renew.product_code"
            filled
            label="Mã sản phẩm"
            @input="debounceInputProductCode"
        ></v-text-field>
      </v-col>
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-select
            filled
            background-color="#EDF2F7"
            class="width-input"
            v-model="renew.status"
            :items="warranty_status"
            item-text="name"
            item-value="id"
            label="Trạng thái"
            @change="getItem2"
            clearable
        ></v-select>
      </v-col>

    </v-row>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="dataSearchRenew"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
              <span>{{ formatDate(item.created_at) }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 2" class="warning--text">ĐANG TƯ VẤN</span>
              <span v-else-if="item.status == 3" class="primary--text">ĐÃ TƯ VẤN</span>
              <span v-else-if="item.status == 4">BỎ QUA</span>
              <span v-else class="red--text">CHƯA TƯ VẤN</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update trade_in_sale')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)" v-if="hasPermissions('Delete trade_in_sale')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_RENEW, GET_DATA_SEARCH_RENEW, GET_LIST_RENEW} from "@/store/modules/renew";
import {debounce} from "debounce";


export default {
  name: "List_Renew",
  data() {
    return {
      page: "Thu cũ đổi mới",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Thu cũ đổi mới",
          disabled: true,
        },
      ],
      headers: [
        {text: 'STT', value: 'id', align: 'start',},
        {text: 'Tên khách hàng', sortable: false, value: 'name'},
        {text: 'Nơi cứ trú', value: 'province_name'},
        {text: 'SĐT ', value: 'phone'},
        {text: 'Mã sản phẩm', value: 'product_sku'},
        {text: 'Thời gian', value: 'created_at'},
        {text: 'Trạng thái', value: 'status'},
        {text: 'Actions', value: 'actions'},
      ],
      warranty_status: [
        {id: 1, name: 'CHƯA TƯ VẤN'},
        {id: 2, name: 'ĐANG TƯ VẤN'},
        {id: 3, name: 'ĐÃ TƯ VẤN'},
        {id: 4, name: 'BỎ QUA'},
      ],
      renew: {
        name: "",
        phone: "",
        address: null,
        product_code: null,
        status: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      renews: "renews",
      dataSearchRenew: "dataSearchRenew",

    }),
  },
  async created() {
    await this.$store.dispatch(GET_LIST_RENEW);
    await this.$store.dispatch(GET_DATA_SEARCH_RENEW);
  },
  methods: {
    debounceInput: debounce(function (e) {
      this.renew.name = e;
      let params = {
        name: this.renew.name,
        phone: this.renew.phone,
        status: this.renew.status,
        product_code: this.renew.product_code,
        province_name: this.renew.address
      };
      this.$store.dispatch(GET_DATA_SEARCH_RENEW, params);

    }, 200),
    debounceInput1: debounce(function (e) {
      this.renew.phone = e;
      let params = {
        name: this.renew.name,
        phone: this.renew.phone,
        status: this.renew.status,
        product_code: this.renew.product_code,
        province_name: this.renew.address
      };
      this.$store.dispatch(GET_DATA_SEARCH_RENEW, params);

    }, 200),
    debounceInputProductCode: debounce(function (e) {
      this.renew.product_code = e;
      let params = {
        name: this.renew.name,
        phone: this.renew.phone,
        status: this.renew.status,
        product_code: this.renew.product_code,
        province_name: this.renew.address
      };
      this.$store.dispatch(GET_DATA_SEARCH_RENEW, params);
    }, 200),
    debounceInputAddress: debounce(function (e) {
      this.renew.address = e;
      let params = {
        name: this.renew.name,
        phone: this.renew.phone,
        status: this.renew.status,
        product_code: this.renew.product_code,
        province_name: this.renew.address
      };
      this.$store.dispatch(GET_DATA_SEARCH_RENEW, params);
    }, 200),
    getItem2() {
      let params = {
        name: this.renew.name,
        phone: this.renew.phone,
        status: this.renew.status,
        product_code: this.renews.product_code,
        province_name: this.renews.address
      };
      this.$store.dispatch(GET_DATA_SEARCH_RENEW, params);

    },
    deleteItem(item) {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_RENEW}`, item.id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_RENEW);
        }
      })
    },
    editItem(item) {
      this.$router.push({
        path: "/trade_in_sale/edit/" + item.id,
      })
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
  }
}
</script>

<style scoped>

</style>